(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridgman-announcement-bar-slider"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const $slider = $('.bridgman-announcement-bar-slider');
    var slickEnabled = false;
    var resizeTimeout = null;

    // Throttle function
    function throttleResize(callback, delay) {
      if (resizeTimeout) return;
      resizeTimeout = setTimeout(function () {
        callback();
        resizeTimeout = null;
      }, delay);
    }

    function toggleSlick() {
      if (window.innerWidth <= 1025) {
        if (!slickEnabled) {
          $slider.slick({
            draggable: true,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            touchThreshold: 1000,
          });
          slickEnabled = true;
        }
      } else {
        if (slickEnabled) {
          $slider.slick('unslick');
          slickEnabled = false;
        }
      }
    }

    if ($slider) {
      toggleSlick();
      $(window).on('resize', function () {
        throttleResize(toggleSlick, 150);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridgman-store-features"] && !Shopify.designMode) return;
  try {
    

  function setEventListeners ( ) 
  {
    window.addEventListener('resize', function ( ) {
        var currentWidth = window.innerWidth;
        if ( currentWidth < 769 ) {
          startAccordian( );
        }
        else {
          var text = document.getElementsByClassName( '.store_features_support_text_container' );
          text.style.maxHeight = text.scrollHeight + "px";
        }
    });
    var currentWidth = window.innerWidth;
    if ( currentWidth < 769 )
    {
      startAccordian( );
    }
  }

  function startAccordian ( )
  {
      var features = document.getElementsByClassName( 'feature-header-container' );
      for ( var i = 0; i < features.length; i++ ) {
        features[ i ].addEventListener( "click", function( ) 
        {
          var text = this.nextElementSibling;
          var close = this.querySelector( '.text_container_closer' );
          if ( text.style.maxHeight == 0 )
          {
            text.style.maxHeight = text.scrollHeight + "px";
            close.classList.add( 'text_container_closer--active' )   
          }
          else
          {
              text.style.maxHeight = null;
              close.classList.remove( 'text_container_closer--active' );
          }   
        });
      }
  }

  setEventListeners( );


  } catch(e) { console.error(e); }
})();
})();
